module.exports = __webpack_public_path__ + "static/media/firstPlaceMedal.ca807c59.svg";